export enum DialogButton {
  ok = 0,
  okCancel = 1,
  yesNo = 2,
  continueCancel = 3,
}
